module.exports = __webpack_public_path__ + "static/img/13.e30e5ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/11/13.png
// module id = mn3r
// module chunks = 0